module.exports = __webpack_public_path__ + "static/img/performance01.8c9a87d3.jpg";